import RestMethod from '../consts/RestMethod'
import RestResultType from '../consts/RestResultType'
const axios = require('axios')

// example
//   restClient(RestCfg.TENANT_NAMELIST).send(data).then(successCase).catch(throwCase);
//     data :
//        get/post -> json object
//        form     -> FormData object
//     successCase :
//        arg      -> {headers: headers, statusCode: string, body: object(depends on type)}

const RestClient = class {
  // コンストラクタ
  constructor(restCfg) {
    this.restCfg = restCfg
  }

  // 送信処理
  send(data) {
    let url = this.restCfg.url
    if (Object.prototype.toString.call(data) === '[object FormData]' && data.get('reqType') === 'lookbook-upload') {
      axios.defaults.timeout = 15000
    } else {
      axios.defaults.timeout = 10000
    }

    switch (this.restCfg.method) {
      // GETメソッドの場合はクエリ文字列を作成
      case RestMethod.GET:
        let query = '?'
        Object.keys(data).forEach(key => {
          query += key + '=' + encodeURIComponent(data[key]) + '&'
        })
        url = this.restCfg.url + query.substring(0, query.length - 1)
        return new Promise((resolve, reject) => {
          axios.get(url, {
            headers: this.restCfg.header
          })
            .then(response => {
              resolve(this.payloadConvert(response))
            })
            .catch(err => {
              reject(err)
            })
        })

      // POSTの場合はjsonデータを送信
      case RestMethod.POST:
        return new Promise((resolve, reject) => {
          axios.post(url, data, {
            headers: this.restCfg.header
          })
            .then(response => {
              resolve(this.payloadConvert(response))
            })
            .catch(err => {
              reject(err)
            })
        })

      // POST(multipart/form-data)の場合はフォームを送信
      case RestMethod.FORM:
        return new Promise((resolve, reject) => {
          axios.post(url, data, {
            headers: this.restCfg.header
          })
            .then(response => {
              resolve(this.payloadConvert(response))
            })
            .catch(err => {
              reject(err)
            })
        })

      default:
        throw new TypeError('Undefined method.')
    }
  }

  // 受信処理
  payloadConvert(response) {
    switch (this.restCfg.resultType) {
      case RestResultType.JSON:
        return { headers: response.headers, statusCode: response.status, body: response.data }

      case RestResultType.BLOB:
        return { headers: response.headers, statusCode: response.status, body: response.blob() }

      case RestResultType.ARRAY_BUFFER:
        return { headers: response.headers, statusCode: response.status, body: response.arrayBuffer() }

      case RestResultType.TEXT:
        return { headers: response.headers, statusCode: response.status, body: response.text() }

      default:
        throw new TypeError('Undefined method.')
    }
  }
}

export default RestClient



// WEBPACK FOOTER //
// ./src/scripts/services/RestClient.js